function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCm360 = function SvgCm360(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg_icon_cm360__svg900",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "svg_icon_cm360__g901",
    style: {
      display: "inline"
    },
    transform: "translate(-1.758 -1.229)scale(.03208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_cm360__path346",
    d: "M302 275c6.202 2.603 15.298 1 22 1-6.202-2.603-15.298-1-22-1",
    style: {
      fill: "#2d994c",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_icon_cm360__g900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_cm360__path9",
    d: "M296 276c7.706-.159 15.236-1.301 23-.961 40.313 1.766 80.602 12.832 116 32.273 16.357 8.983 29.83 21.127 45 31.688-1.858-4.91-5.048-9.16-7.127-14-4.906-11.42-7.378-23.583-6.834-36 1.999-45.567 45.023-81.638 89.961-76.826 13.407 1.435 27.176 7.075 38 14.985 5.486 4.009 9.815 9.179 15 13.516 8.142 6.812 17.883 12.504 28 15.805 36.894 12.037 80.491-2.836 100.547-36.48 11.545-19.367 14.296-42.088 10.283-64-4.739-25.881-24.133-44.291-43.83-59.996C658.48 59.709 602.774 42 545 42c-96.836 0-186.251 57.915-226.691 146-8.02 17.467-14.133 36.098-17.698 55-2.063 10.942-2.587 22.098-4.611 33",
    style: {
      fill: "#1e8e3e",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_cm360__path161",
    d: "M737 129c4.926 13.536 12.306 25.073 12.961 40 2.011 45.88-33.729 89.817-80.961 91.961-13.726.623-27.629-2.23-40-8.219-6.537-3.165-12.291-8.161-19-10.742 11.205 18.157 19.424 35.027 17.911 57-2.804 40.718-43.107 78.873-84.911 74.83-14.399-1.392-29.291-5.882-41-14.591-10.45-7.773-18.875-18.338-29-26.625-20.206-16.538-43.365-30.819-68-39.753-23.008-8.344-47.498-15.054-72-16.772C232.644 269.056 134.044 322.418 88.753 413c-10.041 20.083-18.574 41.725-22.318 64-11.814 70.291 1.096 142.078 44.195 200 6.588 8.855 13.94 16.772 21.241 25 2.486 2.801 4.264 6.251 7.183 8.651C179.51 743.924 243.866 737.443 274.279 694c5.428-7.755 9.478-16.704 11.435-26 3.884-18.458.369-37.295-7.984-54-3.481-6.962-10.736-13.679-12.73-21-8.002-5.637-14.613-13.878-19.996-22-8.281-12.493-13.825-28.882-13.825-44 0-58.851 68.664-100.144 119.821-70.535 9.987 5.78 18.394 14.121 25 23.535 8.359 1.907 17.032 12.196 24 17.37 13.589 10.091 28.628 18.283 44 25.321 58.844 26.944 129.401 28.474 190 6.256 22.379-8.205 43.901-19.54 63-33.842C781.472 431.848 816.966 321.938 788 221c-6.952-24.224-17.678-47.025-31.667-68-5.496-8.241-11.284-18.075-19.333-24",
    style: {
      fill: "#5bb974",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_cm360__path548",
    d: "M377 479c1.903 5.02 5.377 9.155 7.68 14 5.754 12.106 8.873 25.586 8.281 39-1.943 43.967-43.483 79.958-86.961 76.911-16.049-1.125-27.605-9.463-42-14.911 10.021 15.165 20.95 30.204 22.829 49 4.736 47.357-36.265 85.787-81.829 88.911-15.901 1.089-31.77-2.605-46-9.72-5.927-2.963-10.999-7.52-17-10.191 5.395 9.389 18.27 16.694 27 22.856 29.17 20.59 63.831 34.399 99 40.224 82.388 13.647 169.265-12.196 226.91-74.08 19.252-20.667 35.027-44.328 46.781-70 12.526-27.356 18.952-57.14 21.309-87-11.538 0-23.513.923-35-.17-36.405-3.464-70.785-13.674-103-31.139-11.303-6.127-21.833-13.504-32-21.342-5.249-4.047-10.003-9.553-16-12.349",
    style: {
      fill: "#34a853",
      stroke: "none"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCm360);
export { ForwardRef as ReactComponent };